
 <template lang="">
 <UserLayout  pageTitle="Agenda personale">
      <template #page-content="props">
         
        <AgendaViewer></AgendaViewer> 
     </template>
 </UserLayout> 
</template>
<script>
import AgendaViewer from "../components/CustomComponentsUI/AgendaViewer";
import UISettingsHelper from "../utils/UISettingsHelper";
import UserLayout from "../layout/UserLayout";
export default {
  components: {
    AgendaViewer,
    UserLayout,
  },
  created(){
    
      UISettingsHelper.Configure(this.$route.params.companyAlias); 
  }
};
</script>
<style lang="">
  
</style> 